import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { NavbarProvider } from "./NavbarContext";

import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";

import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <div>
      <NavbarProvider>
        <Router>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />  
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </Router>
      </NavbarProvider>
    </div>
  );
}

export default App;
